var map = {
	"./ebirah_full.png": 8274,
	"./ebirah_game.png": 6502,
	"./ebirah_moves.png": 6512,
	"./ebirah_side.png": 6326,
	"./general_game.png": 6913,
	"./general_side.png": 3252,
	"./giant_squid_full.png": 925,
	"./giant_squid_game.png": 1973,
	"./giant_squid_moves.png": 686,
	"./giant_squid_side.png": 4314,
	"./jormungandr_full.png": 1957,
	"./jormungandr_game.png": 1248,
	"./jormungandr_moves.png": 4642,
	"./jormungandr_side.png": 9978,
	"./kraken_full.png": 7791,
	"./kraken_game.png": 4751,
	"./kraken_moves.png": 7452,
	"./kraken_side.png": 9515,
	"./leviathan_full.png": 7447,
	"./leviathan_game.png": 8956,
	"./leviathan_moves.png": 9753,
	"./leviathan_side.png": 4190,
	"./loch_ness_full.png": 1195,
	"./loch_ness_game.png": 8421,
	"./loch_ness_moves.png": 8233,
	"./loch_ness_side.png": 6637,
	"./megalodon_full.png": 9736,
	"./megalodon_game.png": 4773,
	"./megalodon_moves.png": 7770,
	"./megalodon_side.png": 9666,
	"./sea_hydra_full.png": 2102,
	"./sea_hydra_game.png": 2054,
	"./sea_hydra_moves.png": 2818,
	"./sea_hydra_side.png": 12,
	"./siren_full.png": 788,
	"./siren_game.png": 9789,
	"./siren_moves.png": 2892,
	"./siren_side.png": 3044,
	"./white_whale_full.png": 3304,
	"./white_whale_game.png": 634,
	"./white_whale_moves.png": 8314,
	"./white_whale_side.png": 3628
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3975;